export default __webpack_public_path__ + "static/forbes-logo-cw-bfe8d12cb06e1b4c677d1cd58cb23475.svg";